<template>
  <div class="content">
    <div class="back-row-frame">
      <div class="v-c-left">
        <div v-show="isMobile()" class="back-arrow">
          <a class="btn-to-back" @click="$router.push('/points/overview')">
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/Angle-left.png`)" alt="">
          </a>
        </div>
        <div v-show="isMobile()" class="title">
          {{ $t('Bao.roulette_bonus') }}
        </div>
      </div>
      <div class="v-c-right">
        <div class="exchange-amount-frame">
          <div class="token-name">
            <span>{{ $t("Bao.roulette_mainturnover") }}</span>
          </div>
          <div class="token-amount">
            <span>{{ point | numberFormat }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view-card mall-min-h">
      <div v-if="!allProd" class="history-list-content if-no-data">
        <div class="no-data">
          <i>
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
          </i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
      </div>
      <div v-else class="view-card-body ticket-list">
        <div
          v-for="(type, key) in allProd"
          :key="key"
          class="ticket-frame"
          @click="showModel(type)"
        >
          <div class="tf-left">
            <div class="bonus-cube">
              <div class="amount">
                {{ type.receive_prize }}
              </div>
              <div class="unit">
                {{ $t('Bao.point_unit') }}
              </div>
            </div>
          </div>
          <div class="tf-right">
            <div class="title">
              {{ $t('Bao.point_prize') }} {{ type.receive_prize }}
            </div>
            <div class="describe">
              {{ $t("Bao.roulette_turnover") }} {{ type.amount }}
            </div>
            <div class="second-half">
              <div class="describe">
                <div class="des-start">
                  {{ $t("Bao.roulette_date") }}
                </div>
                <div class="des-end">
                  {{ formatDate(type.created_at) }}
                </div>
              </div>
              <div>
                <a v-if="isLocked(type.amount)" class="btn btn-exchange lock">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-lock.png`)" alt="">
                </a>
                <a v-else class="btn btn-exchange">
                  {{ $t("Bao.redeem") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-purchase-modal :is-active="showModal" :selected-prod="selectedProd" @hideModel="hideModel" />
    </div>
  </div>
</template>

<script>
import { getAllProductInfo, purchaseProd } from '@/api/shop'
import { detectMob, refreshGold, showNotice } from '@/utils/tool'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'

export default {
  components: {
    confirmPurchaseModal
  },
  data() {
    return {
      allProd: [],
      showModal: false,
      selectedProd: {}
    }
  },
  computed: {
    point() {
      const main_turnover = this.$store.getters.mainTurnover
      return parseFloat(main_turnover)
    }
  },
  watch: {
    '$store.state.user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_SHOP_PURCHASE', false)
      }
    }
  },
  created() {
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProductInfo()
  },
  methods: {
    getAllProductInfo() {
      getAllProductInfo({ catalog: JSON.stringify('daily_lottery') }).then((response) => {
        this.allProd = response.data.data.data.daily_lottery
        if (this.allProd && this.allProd.length > 0) {
          this.allProd = this.allProd.map(prod => ({
            ...prod,
            name: prod.receive_prize + this.$t('Bao.point_unit'),
            type: 3,
            type_name: this.$t('Bao.point_type_roulette'),
            availBuy: !this.isLocked(prod.amount)
          }))
            .sort((a, b) => b.receive_prize - a.receive_prize)
        }
      })
        .then(
          refreshGold()
        )
        .catch(error => {
          showNotice(error.response.data.msg)
        })
    },
    isMobile() {
      return detectMob()
    },
    isLocked(amount) {
      if (this.$store.getters.token) {
        return parseFloat(amount) > parseFloat(this.$store.state.user.memberInfo.main_turnover)
      }
    },
    buyProd(prod) {
      purchaseProd({ id: prod.id }).then((response) => {
        showNotice(this.$t('Bao.success1'))
        this.getAllProductInfo()
      }).catch(() => {
        showNotice(this.$t('Bao.roulette_turnover_lack'))
      })
    },
    formatDate(timestamp) {
      const date = new Date((timestamp + 73 * 3600) * 1000)
      // 有效時間,因為我們是＋8的時區～但日本是＋9, 得用created_at的時間＋73小時

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    showModel(prod) {
      this.selectedProd = prod
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    }
  }
}
</script>

<style scoped>

</style>
